// @flow
import React from 'react';

import picki from '../../assets/svg/cards/picki.svg';
import bubi from '../../assets/svg/cards/bubi.svg';
import chervi from '../../assets/svg/cards/chervi.svg';
import kresti from '../../assets/svg/cards/kresti.svg';
import no from '../../assets/svg/cards/no.svg';
import styles from './styles.module.scss';

const mastsImage = {
  picki,
  bubi,
  chervi,
  kresti,
  no,
};

type Props = {
  mast: 'picki' | 'bubi' | 'chervi' | 'kresti' | 'no';
  bg: 'green' | 'red' | 'black' | 'grey' | 'blank';
  size: 'big' | 'small';
  value: | 'A'
    | 'K'
    | 'Q'
    | 'J'
    | 'T'
    | '9'
    | '8'
    | '7'
    | '6'
    | '5'
    | '4'
    | '3'
    | '2';
};

const Card = ({
  bg, mast, size, value,
}: Props) => (
  <div className={`${styles.container} ${styles[bg]} ${styles[size]}`}>
    {mast !== 'no' ? (
      <img src={mastsImage[mast]} alt="mast" className={styles.mast} />
    ) : null}
    <div className={styles.value}>{value}</div>
  </div>
);

export default Card;
